import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useGetKafdActiveRegularLocations } from "src/api/kafd-prebooking";
import AllMap from "./map";

const KafdAllLocationsMap: React.FC = () => {
  const { i18n } = useTranslation();

  const { data } = useGetKafdActiveRegularLocations();

  return (
    <Box>
      {!data ? (
        <Box
          height={"800px"}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <CircularProgress />
        </Box>
      ) : (
        <AllMap list={data?.locations} />
      )}
    </Box>
  );
};

export default KafdAllLocationsMap;
